import React from "react";
import { Printer, History, Eye } from "lucide-react";
import SurgeonFactorPopover from "@/components/SurgeonFactorPopover";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

export default function HeaderBar({
  onOpenHistory, onPrint, onLoadSample, surgeonFactor, onApplySF,
  currentLensSF, currentLensName, onApplyLensSF, onApplyLensC, onOpenTrends,
}) {
  return (
    <header className="no-print sticky top-0 z-40 backdrop-blur-md bg-white/85 border-b border-slate-200">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-3 flex items-center gap-2 sm:gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-9 h-9 rounded-lg bg-sky-700 text-white grid place-items-center shadow-sm hidden sm:grid">
            <Eye className="w-5 h-5" strokeWidth={2.4} />
          </div>
          <div className="leading-tight">
            <div className="font-serif text-sm sm:text-lg font-semibold tracking-tight whitespace-nowrap">OculoPrecision</div>
            <div className="text-[11px] uppercase tracking-widest text-slate-500 font-medium hidden sm:block" data-testid="app-tagline">
              The All-in-One Automated AI Solution for Eye Healthcare
            </div>
          </div>
        </div>

        <div className="ml-auto flex items-center gap-2">
          <SurgeonFactorPopover
            surgeonFactor={surgeonFactor}
            currentLensSF={currentLensSF}
            currentLensName={currentLensName}
            onApplySF={onApplySF}
            onApplyLensSF={onApplyLensSF}
            onApplyLensC={onApplyLensC}
            onOpenTrends={onOpenTrends}
          />

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="sm" data-testid="load-sample-btn">
                <span className="hidden sm:inline">Load Sample</span><span className="sm:hidden">Sample</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-72">
              <DropdownMenuLabel>Preset clinical cases</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem data-testid="sample-normal" onClick={() => onLoadSample("normal")}>
                Normal Eye — Haigis
              </DropdownMenuItem>
              <DropdownMenuItem data-testid="sample-anisometropia" onClick={() => onLoadSample("anisometropia")}>
                AL Anisometropia — Alert
              </DropdownMenuItem>
              <DropdownMenuItem data-testid="sample-post-lasik" onClick={() => onLoadSample("postLasik")}>
                Post-LASIK — Barrett True-K
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <Button variant="outline" size="sm" onClick={onOpenHistory} data-testid="history-btn">
            <History className="w-4 h-4 sm:mr-1.5" /> <span className="hidden sm:inline">History</span>
          </Button>
          <Button size="sm" onClick={onPrint} data-testid="print-btn" className="bg-slate-900 hover:bg-slate-800 text-white">
            <Printer className="w-4 h-4 sm:mr-1.5" /> <span className="hidden sm:inline">Print Report</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
